<div class="notifications no-print" *ngIf="notifications">
  <div
    class="notification"
    *ngFor="let notification of notifications"
    [@simpleFadeAnimation]="'in'"
  >
    <bom-alert
      [type]="notification.type"
      [titleHtml]="notification.title"
      [descriptionHtml]="notification.message"
      [descriptionHtmlSanitized]="notification.messageSanitized"
    >
      <svg
        *ngIf="notification.hideOnClick"
        class="icon-svg"
        (click)="handleNotificationClick(notification)"
        [attr.title]="'Notifikation.Luk' | tekstresource"
      >
        <use xlink:href="#close"></use>
      </svg>
    </bom-alert>
  </div>
</div>
